module.exports = __webpack_public_path__ + "img/ico-down.a7506ccd.svg";